import { GET, POST } from "services/httpService";
import { getAppConfig } from "services/configService";

const apiUrl = () => {
  return getAppConfig().ReorderApiUrl;
};

export const getReorderStatus = (requestInfo, productCode) => {
  return GET(requestInfo, apiUrl() + `/reorder/status/${productCode}`);
};

export const addToBasket = (requestInfo, productCode) => {
  return POST(requestInfo, apiUrl() + `/reorder/${productCode}/addtobasket`);
};
